// Simplified demo service for landing page (no Supabase dependency)
export const demoService = {
  async uploadDemoImages(personImage, clothingImage, clothingId) {
    // Simulate upload delay
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    // Return mock data for demo purposes
    return {
      success: true,
      data: {
        userImage: {
          publicUrl: personImage,
          filePath: `demo/user-${Date.now()}.jpg`
        },
        clothingImage: {
          publicUrl: clothingImage,
          filePath: `demo/clothing-${clothingId}-${Date.now()}.jpg`
        }
      }
    };
  }
};